<div> 
    <app-analise-margem-bi02-filtro
          [filtros]="filtros">
    </app-analise-margem-bi02-filtro>
    <app-analise-margem-bi02-lista
          [filtros]="filtros"
          (definirFiltro)="definirFiltro()"
          (exibir)="selecionar($event)">
    </app-analise-margem-bi02-lista>
   </div>